<template>
    <div class="full-wdith-view" v-loading="loading">
        <div v-show="viewPart === 'list'">
            <div class="operation-btns" v-if="false !== useAddBtn">
                <div>
                    <span>&nbsp;</span>
                </div>

                <div>
                    <el-button @click="goAdd" tkey="添加">{{i18n.tkey("lang_add")}}</el-button>
                </div>
            </div>

            <div class="data-list">
                <CreatedMallList
                    v-if="viewPart === 'list'"
                    :list="dataList"
                    @clickEdit="goEdit"
                    @clickView="goView"
                    @clickGoOrder="goOrder"
                />
            </div>
        </div>

        <div v-if="viewPart === 'edit'">
            <EditorTitle
                :showReturnBtn="true"
                :returnLabel="i18n.tkey('return')"
                :showOperationBtn="false"
                :titleLabel="i18n.tkey('lang_mall_manage')"
                @clickReturnBtn="clickReturnBtn"
            />

            <AddOrEditCreatedMall
                :companyObj="companyObj"
                :editObj="editObj"
                :readonlyTag="readOnlyTag"
                @save-complete="saveCallback"
            />
        </div>


      <div v-show="viewPart === 'order'||viewPart === 'orderInfo'">
        <div class="operation-btns" v-if="false !== useAddBtn">
          <div style="padding: 8px 16px">
            <ReturnButton
                class="return-btn"
                @click="clickReturn"
                :label="i18n.tkey('lang_return')"
            />
          </div>

        </div>
        <hallOrder
            v-if="viewPart === 'order'||viewPart === 'orderInfo'"
            :editObj="editObj"
            :viewPart="viewPart"
            @clickChangeViewPart="changeView"
        />
      </div>

    </div>
</template>

<script setup>

import {inject, getCurrentInstance, ref, toRef, onBeforeMount} from "vue";
import CreatedMallList from "@/components/shopopee/mall/createdMallList.vue";
import AddOrEditCreatedMall from "@/components/shopopee/mall/addOrEditCreatedMall.vue";
import record14Api from "@/request/record14Api";
import myUtil from "@/util/util";
import EditorTitle from "@/components/shopopee/common/editorTitle.vue";
import HallOrder from "@/components/shopopee/hall/hallOrder.vue";
import AddOrEditSponsor from "@/components/shopopee/hall/addOrEditSponsor.vue";
import SponsorList from "@/components/shopopee/hall/sponsorList.vue";
import ReturnButton from "@/components/shopopee/common/returnButton.vue";

const props = defineProps(["companyObj", "useAddBtn"])
const emits = defineEmits(["goEdit", "goList"])

const i18n = inject("i18n")
const loading = ref(false)

const dataList = ref([])
const viewPart = ref("list")

const editObj = ref(null)
const readOnlyTag = ref(false)

function getRecordList(){
    loading.value = true

    const request = record14Api.getMallInfoList
    const params = request.getParams()

    params.addinfo17 = "1"
    params.companycode = props.companyObj.companycode
    params.addinfo18 = "-1"

    if (null != props.companyObj.additionalrecord11 && null != props.companyObj.additionalrecord11.addremark1){
        const authObj = props.companyObj.additionalrecord11.addremark1

        if (authObj.islandNum > 0){
            params.addinfo18 = "-1"
        }

    }

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            dataList.value = res.detail
        }else{
            myUtil.alertError(res.msg)
        }
    })

}


function changeView(mviewPart){
  viewPart.value = mviewPart
}

function goEdit(obj){
    editObj.value = obj
    readOnlyTag.value = false
    emits("goEdit")
    viewPart.value = "edit"
}

function goView(obj){
    editObj.value = obj
    readOnlyTag.value = true
    emits("goEdit")
    viewPart.value = "edit"
}
function goOrder(obj){

  editObj.value = obj
  viewPart.value = "order"
  //titleName.value = i18n.tkey('lang_custom_order')
}

function clickReturnBtn(){
    editObj.value = null
    readOnlyTag.value = false
    emits("goList")
    viewPart.value = "list"
    getRecordList()
}

function goAdd(){
    if (null != props.companyObj.additionalrecord11){
        if (null != props.companyObj.additionalrecord11.mallNum && props.companyObj.additionalrecord11.mallNum > dataList.value.length){
            editObj.value = null
            readOnlyTag.value = false
            emits("goEdit")
            viewPart.value = "edit"
        }else{
            myUtil.alertWarning(i18n.tkey("lang_mall_limit_alert"))
        }
    }else{
        myUtil.alertWarning(i18n.tkey("lang_mall_limit_alert"))
    }
}
function clickReturn(){
  if(viewPart.value == "orderInfo"){
    viewPart.value = "order"
  }else {
    viewPart.value = "list"
  }
}

function saveCallback(){
    clickReturnBtn()
}

onBeforeMount(() => {
    getRecordList()
})


</script>

<style scoped>
    .full-wdith-view {
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        box-sizing: border-box;
    }

    .operation-btns {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .data-list {
        margin-top: 25px;
    }
</style>